import { graphql } from 'react-relay';
import { genericMutation } from '../utils';
import type { EmailSender_Mutation } from './__generated__/EmailSender_Mutation.graphql';

const EmailSenderMutation = graphql`
  mutation EmailSender_Mutation($input: EmailSenderInput!) {
    emailSender(input: $input) {
      message
      origin
      sent
      to
    }
  }
`;

export const sendEmail = genericMutation<EmailSender_Mutation>({
  mutation: EmailSenderMutation,
});
